<template>
    <div class="report-summary">
        <h6 class="font-weight-bold my-3">Customer Feedback:</h6>
        <div>
            <div class="d-flex flex-row justify-content-center mb-3">
                <counter v-bind:to="feedback.all" label="Total Submissions"></counter>
                <counter v-bind:to="feedback.month" label="This Month"></counter>
                <div class="counter p-2 flex-fill text-center">
                    <h2>{{ (Math.round(feedback.average.all * 100) / 100).toFixed(1) }}</h2>
                    <p>Avg. Rating</p>
                </div>
                <div class="counter p-2 flex-fill text-center">
                    <h2 v-if="feedback.month > 0">{{ (Math.round(feedback.average.month * 100) / 100).toFixed(1) }}</h2>
                    <h2 v-else>-</h2>
                    <p>Avg. Rating (Month)</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ReportPageFeedback",
        props: ['feedback']
    }
</script>

<style scoped>

</style>
